// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/attention.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ListAttentionRequest, ListAttentionResponse, ResolveAttentionRequest, ResolveAttentionResponse } from "./attention_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * AttentionService is the browser edge for SAD-431 actionable shared-information
 * attention. Each RPC wraps pangaea's AttentionGatewayService; the viewer
 * (tenant + user) is resolved from the session, never trusted from the body.
 * Pangaea re-checks the viewer's permission on every read, so an item the
 * viewer can no longer see is absent -- no title, snippet or count.
 *
 * @generated from service mono.projectdata.v1.AttentionService
 */ export const AttentionService = {
    typeName: "mono.projectdata.v1.AttentionService",
    methods: {
        /**
     * ListAttention lists the signed-in user's open, currently permitted items.
     *
     * @generated from rpc mono.projectdata.v1.AttentionService.ListAttention
     */ listAttention: {
            name: "ListAttention",
            I: ListAttentionRequest,
            O: ListAttentionResponse,
            kind: MethodKind.Unary
        },
        /**
     * ResolveAttention stamps one of the signed-in user's own items resolved
     * (history is kept).
     *
     * @generated from rpc mono.projectdata.v1.AttentionService.ResolveAttention
     */ resolveAttention: {
            name: "ResolveAttention",
            I: ResolveAttentionRequest,
            O: ResolveAttentionResponse,
            kind: MethodKind.Unary
        }
    }
};
